exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-menu[data-v-97ff6b0c] {\n    width: 400px;\n}\n", ""]);

// exports
